import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { Control } from "react-hook-form";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import { SearchSelectMulti } from "../../../components/common/form/SearchSelect/SearchSelectMulti";
import { useGetDegreesBySchoolByQueryQuery } from "@axio/graphql/generated/graphql";
import { useAppConfig } from "../../../AppConfigProvider";

interface AddCourseDegreesStepProps {
  control: Control;
}

const AddCourseDegreesStep: React.FC<AddCourseDegreesStepProps> = ({ control }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { primaryColor, axioSchools } = useAppConfig();

  const schoolId = axioSchools[0];

  const {
    refetch: degreesRefetch,
    data: degreesData,
    loading,
  } = useGetDegreesBySchoolByQueryQuery({
    variables: {
      schoolId,
      searchQuery,
      page: 1,
      pageSize: 100,
    },
  });

  useEffect(() => {
    degreesRefetch();
  }, [searchQuery]);

  return (
    <View style={styles.formGroup}>
      <CustomText text="Course Degrees" size="s" textType="text" style={{ color: "#182230" }} weight="ultraBold" />
      <CustomText
        text="Select one or more degrees to associate with this course"
        size="xs"
        style={{ color: "#6B7280", marginBottom: 8 }}
        useTranslationText={false}
      />
      <SearchSelectMulti
        name="degrees"
        control={control}
        label=""
        loading={loading}
        placeholder="Start typing to search or select from the list below"
        backgroundColor={primaryColor}
        showAllByDefault={true}
        height={200}
        itemType="degree"
        fetchOptions={async (searchQuery) => {
          setSearchQuery(searchQuery);

          return (
            degreesData?.getDegreesBySchoolByQuery?.data.degrees.map((d) => ({
              id: d.id,
              name: d.name,
            })) ?? []
          );
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  formGroup: {
    marginBottom: 24,
  },
});

export default AddCourseDegreesStep;
